/* eslint-disable max-classes-per-file */
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { SelectionItem } from "~app/common/components/tree-selector/selection-item";
import { AreaSelectionMarknadsomrade } from "~app/common/models/areaSelector";
import { ITypSelectValue } from "~app/common/models/selectValueModel";
import { ApiClientService } from "~app/common/services/api-client.service";
import { IVerksamhetsomraden } from "./regelverk-viol.models";

export class Vardegrupper {
    static readonly affarsform: string = "AFFARSFORM";
    static readonly atgardsgrupp: string = "ATGARDSGRUPP";
    static readonly avverkningsgrupp: string = "AVVERKNINGSGRUPP";
    static readonly byl: string = "BYL";
    static readonly diameterfordelning: string = "DIAMETERFORDELNING";
    static readonly kontraktstatus: string = "KONTRAKTSTATUS";
    static readonly kvalitet: string = "KVALITET";
    static readonly lutning: string = "LUTNING";
    static readonly lutningsriktning: string = "LUTNINGSRIKTNING";
    static readonly malklass: string = "MALKLASS";
    static readonly markfuktighet: string = "MARKFUKTIGHET";
    static readonly matmetoder: string = "MATMETODER";
    static readonly mattslag: string = "MATTSLAG";
    static readonly metod: string = "METOD";
    static readonly planeringsstatus: string = "PLANERINGSSTATUS";
    static readonly tillganglighetsklass: string = "TILLGANGLIGHETSKLASS";
    static readonly tradskikt: string = "TRADSKIKT";
    static readonly ursprung: string = "URSPRUNG";
    static readonly vegetationsTyp: string = "VEGETATIONSTYP";
    static readonly vrakorsak: string = "VRAKORSAK";
    static readonly ytstruktur: string = "YTSTRUKTUR";
    static readonly vkMattslag: string = "VK_MATTSLAG";
}

@Injectable({
    providedIn: "root"
})
export class RegelverkViolService {
    url: string;

    avverkningsformer: any[] = [
        {
            kod: "F",
            namn: "Föryngringsavverkning"
        },
        {
            kod: "G",
            namn: "Gallring"
        },
        {
            kod: "O",
            namn: "Okänd"
        }
    ];

    private readonly http = inject(ApiClientService);

    constructor() {
        this.url = "administration/styrtabeller";
    }

    getVarden(vardegrupp: Vardegrupper): Observable<ITypSelectValue[]> {
        return this.http.get<any>("varden").pipe(
            map(affarsformer => affarsformer
                .filter(affarsform => affarsform.grupp === vardegrupp)));
    }

    mapToSelectedVerksamhetsomrade(selectedLista, verksamhetsOmraden: AreaSelectionMarknadsomrade[], result: IVerksamhetsomraden[] = []): IVerksamhetsomraden[] {
        if (!selectedLista) {
            return result;
        }

        this.mapToVerksamhetsomradenList(selectedLista, verksamhetsOmraden, result);

        return result;
    }

    getSelectedVerksamhetsomraden(selectedItems: SelectionItem[]): string[] {
        const selected: string[] = [];
        selectedItems.forEach(mo => {
            if (mo.selected) {
                selected.push(mo.value);
            }
            mo.children.forEach( ro => {
                if (ro.selected) {
                    selected.push(ro.value);
                }
                ro.children.forEach(po => {
                    if (po.selected) {
                        selected.push(po.value);
                    }
                });
            });
        });
        return selected;
    }

    // eslint-disable-next-line sonarjs/cognitive-complexity
    private mapToVerksamhetsomradenList(selectedLista, verksamhetsomradenList, result) {
        for (const marknadsomraden of verksamhetsomradenList) {
            let moPreviouslySelected = false;
            const previousResultatomradeId: string[] = [];
            let resultatomradeId = "";

            for (const selected of selectedLista) {
                const isMo = marknadsomraden && marknadsomraden.guid === selected;
                const isRo = marknadsomraden && marknadsomraden.children.some(ro => ro.guid === selected);
                const isPo = marknadsomraden && marknadsomraden.children.some(ro => ro.children.some(po => po.guid === selected));

                if (isRo) {
                    previousResultatomradeId.push(marknadsomraden.children.find(ro => ro.guid === selected).id);
                } else if (isPo) {
                    for (const ro of marknadsomraden.children) {
                        const foundPo = ro.children.find(po => po.guid === selected);
                        if (foundPo) {
                            resultatomradeId = foundPo.resultatomradeId;
                        }
                    }
                }

                if (isMo) {
                    this.tryAddMo(marknadsomraden, selected, result);
                    moPreviouslySelected = true;
                } else if (isRo && !moPreviouslySelected) {
                    this.tryAddRo(marknadsomraden, selected, result);
                } else if (isPo && (!moPreviouslySelected && !previousResultatomradeId.includes(resultatomradeId))) {
                    this.tryAddPo(marknadsomraden.children, marknadsomraden.guid, selected, result);
                }
            }
        }
    }
    private tryAddMo(mo: any, selected: any, result: IVerksamhetsomraden[]) {
        if (selected === mo.guid) {
            result.push({
                marknadsomrade: mo.guid,
                produktionsomrade: undefined,
                resultatomrade: undefined
            });
        }
    }

    private tryAddRo(mo: any, selected: any, result: IVerksamhetsomraden[]) {
        for (const ro of mo.children) {
            if (selected === ro.guid) {
                result.push({
                    marknadsomrade: mo.guid,
                    produktionsomrade: undefined,
                    resultatomrade: ro.guid
                });
                return;
            }
        }
    }

    private tryAddPo(mo, moGuid, selected, result: IVerksamhetsomraden[] = []) {
        for (const ro of mo) {
            for (const po of ro.children) {
                if (selected === po.guid) {
                    result.push({
                        marknadsomrade: moGuid,
                        produktionsomrade: po.guid,
                        resultatomrade: ro.guid
                    });
                    return;
                }
            }
        }
    }
}
